import { Icon, IconProps } from "../Icon";

const DiamondFill = (props: IconProps) => (
  <Icon {...props}>
    <path d="M9 5L1 14L16 29L31 14L23 5H9Z" fill="currentColor" />
  </Icon>
);

export default DiamondFill;
